import { HeaderNavigation as BaseHeaderNavigation } from '@connected/ui/features/navigation';
import { useTranslation } from 'react-i18next';

import type { LinkRoute } from '@/config/navigation-config';

import { useHeaderNavigation } from '@/hooks/use-navigation';

// ============================================================================
// Component
// ============================================================================

/**
 * Renders Page.Header.Nav with tabs based on the current route.
 * Automatically finds the parent route's nested tabs for the current path.
 *
 * @example
 * // In a layout route that may have tabs
 * <HeaderNavigation />
 */
export function HeaderNavigation() {
    const { t } = useTranslation('navigation');

    return (
        <BaseHeaderNavigation
            useHeaderNavigation={useHeaderNavigation}
            renderLabel={(route: LinkRoute) => t(route.name)}
        />
    );
}
